(function(angular) {
	angular.module('bizPartEngage').controller('modules.cms.page', pageController);
    pageController.$inject = ["$rootScope", "modules.cms.service", "$stateParams", "container", "bizContainerService", "bizContainerUrls", "bizContainerSettings", "MetadataService", "$filter", "bizRuntimeContainerService", "bizPageSurfaceService"];

    function pageController($rootScope, cmsService, $stateParams, container, bizContainerService, bizContainerUrls, bizContainerSettings, MetadataService, $filter, bizRuntimeContainerService, bizPageSurfaceService) {
        var vm = this;
        vm.PageIdentifier = $stateParams.id;
		vm.ContainerVersion = 1;

        vm.GetCMSPage = GetCMSPage;

        bizContainerSettings.ContainerRefererType = "CMS";

        vm.uiOnParamsChanged = function (changedParams, transition) {
        	$rootScope.$broadcast('DYNAMIC_PARAMS_CHANGED', changedParams);
        }

        function GetCMSPage() {
        	vm.GettingCMSPage = true;

            cmsService.GetCMSPage(vm.PageIdentifier).then(GetCmsPageSuccess, GetCmsPageReject);

            function GetCmsPageReject(response) {
                vm.NoAccess = true;
            }

            function GetCmsPageSuccess(response) {
                vm.Page = response.data;
                var containerInfo = bizRuntimeContainerService.PrepareContainer(vm.Page.Container);
                vm.Page.Container = containerInfo.Container;
                vm.ContainerVersion = containerInfo.Version;
                bizPageSurfaceService.ApplyFromContainer(vm.Page.Container);
                $rootScope.DisableMainMenuSticky = !$rootScope.menuSettings.IsSticky;
                vm.GettingCMSPage = false;

                if (!containerInfo.IsV2 && vm.Page.Container && vm.Page.Container.hasStickyNavigation())
                    $rootScope.DisableMainMenuSticky = true;

                var imageUrl = vm.Page.ImageUrl || bizRuntimeContainerService.GetImageUrl(vm.Page.Container, vm.ContainerVersion);

                MetadataService.setMetaTags({
                    title: vm.Page.Title,
                    description: vm.Page.Description,
                    keywords: vm.Page.Keywords,
                    img: imageUrl,
                    type: 'website',
                    canonicalPath: ~~portalSettings.PublicStartPageTabId === vm.Page.Id
                        ? '/'
                        : vm.Page.CanonicalPath || '/page/' + (vm.Page.UrlRewrite || vm.PageIdentifier),
                    excludeFromExternalIndex: vm.Page.ExcludeFromExternalIndex
                });
            }
        }

        vm.$onInit = function() {
            vm.GetCMSPage();
        }
    }

})(window.angular);
